import { GameIdentity } from '@/components/game/_domain/models/game-identity';
import { IGameRepresentation } from '@/components/game/_domain/models/game-representation';
import { IHamsterRaceTicketSetConfigurationViewModel } from '@/app-modules/config/models/hamster-race-ticket-set-response-view-model';

enum GameState {
  InPlay = 'In play',
  Purchasing = 'Purchasing',
  WinnersDisplayed = 'Winners'
}

interface IGameConfiguration {
  maxNumberOfCallsPerGame: number;
  showCallsAsImages: boolean;
  callSkins: string[];
  gameViewComponentName: string;
  jackpotValues: number[];
  callNames: string[];
  initialCallValue: number;
}

interface IGame {
  gameIdentity: GameIdentity;
  gameConfiguration: IGameConfiguration;
  connectionDebugInfo: string;
  state: GameState;
  representation?: IGameRepresentation;
}

interface IHamsterRaceGame extends IGame {
  hamsterConfig?: IHamsterRaceTicketSetConfigurationViewModel;
}

export { IGame, IGameConfiguration, IGameRepresentation, GameState, IHamsterRaceGame };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/_domain/models/game-state.ts